export default "__VITE_ASSET__CW9Pmupi__"